export default __webpack_public_path__ + "static/media/gallery-wip-steel-core_02.e55e08db.jpg";